import {createFileRoute} from '@tanstack/react-router'

import FunnelScreen from '@protected/funnel'

export const Route = createFileRoute('/_protected/funnel')({component: FunnelScreen})
